export default {
  lscsPath: 'http://cmsappdev01.hktdc.org/lscs/v1/document$',
  projectNamePath: '/default/main/',
  apiContext: '/default/main/%%PROJECTNAME%%/WORKAREA/default',
  subDirectoryPath: '/preview',
  routePathTo: `/preview/${process.env.REACT_APP_TSPROJECTNAME}`,
  projectDomain: `https://${process.env.REACT_APP_WTDCS_DOMAIN}`,
  locationServiceEndPoint: `/${process.env.REACT_APP_TSPROJECTNAME}/api/location-service`,
  footer_js_env: '-sit',
  autoCompletePath: 'https://api-fair-uat.hktdc.com/fair-core/v1/auto-complete',
  eventPath: 'https://event-uat.hktdc.com',
  researchDomain: 'https://research-sit.hktdc.com',
  sbeProgramePath: 'https://api-cms-sit.hktdc.com/sbe/v1/seminar/programme',
  sbeSpeakerPath: 'https://api-cms-sit.hktdc.com/sbe/v1/seminar/speakers',
  googleCaptchaPath: `/${process.env.REACT_APP_TSPROJECTNAME}/api/recaptcha/verify`,
  googleSitekey: process.env.REACT_APP_CAPTURA_GOOGLE_SITEKEY1+process.env.REACT_APP_CAPTURA_GOOGLE_SITEKEY2+process.env.REACT_APP_CAPTURA_GOOGLE_SITEKEY3,
  tencentCaptchaPath: `/${process.env.REACT_APP_TSPROJECTNAME}/api/tencent/verify`,
  tencentCaptchaAppId: process.env.REACT_APP_CAPTURA_TENCENT_CAPTCHA_APP_ID1+process.env.REACT_APP_CAPTURA_TENCENT_CAPTCHA_APP_ID2+process.env.REACT_APP_CAPTURA_TENCENT_CAPTCHA_APP_ID3,
  epcPath: "https://home-uat.hktdc.com/epc/webservice/subscription",
  epcAppId: 19,
  captchaLocationPath: "https://api-cms-uat.hktdc.com/captcha/location",
  xApiKey: process.env.REACT_APP_CAPTURA_API_KEY1+process.env.REACT_APP_CAPTURA_API_KEY2+process.env.REACT_APP_CAPTURA_API_KEY3,
};
